import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from "@angular/material/form-field";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fadeInUp400ms } from "src/@vex/animations/fade-in-up.animation";
import { stagger40ms } from "src/@vex/animations/stagger.animation";
import { TableColumn } from "src/@vex/interfaces/table-column.interface";
import {
  PublicationWithRelations,
  PublicationTranslationWithRelations,
} from "src/app/api/models";

@Component({
  selector: "app-item-preview-publications",
  templateUrl: "./publications.component.html",
  styleUrls: ["./publications.component.scss"],
  animations: [fadeInUp400ms, stagger40ms],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: "fill",
      } as MatFormFieldDefaultOptions,
    },
  ],
  standalone: false,
})
export class ItemPreviewPublicationsComponent implements OnInit, AfterViewInit {
  @Input() publications: PublicationWithRelations[] = [];
  @Input() lang: string = "cs";

  /** Main Data */
  tableData: PublicationWithRelations[] = [];

  /** Support Data */

  // Table Properties
  pageSize = 10;
  pageSizeOptions: number[] = [];
  dataSource: MatTableDataSource<PublicationWithRelations> =
    new MatTableDataSource([]);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  //Table Default Values
  DEFAULT_SORT: Sort = { active: "year", direction: "desc" };

  TABLE_COLUMNS: TableColumn<PublicationWithRelations>[] = [
    {
      label: "Název publikace",
      property: "originalTitle",
      type: "text",
      visible: true,
      cssClasses: ["font-semibold"],
    },
    {
      label: "Rok vydání",
      property: "year",
      type: "text",
      visible: true,
    },
  ];

  constructor() {}

  ngOnInit(): void {
    this.tableData = this.publications;
    this.dataSource.data = this.publications;
    this.sort.active = this.DEFAULT_SORT.active;
    this.sort.direction = this.DEFAULT_SORT.direction;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngAfterViewInit() {
    // this.sort.active = this.DEFAULT_SORT.active;
    // this.sort.direction = this.DEFAULT_SORT.direction;
    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
  }

  getTranslation(
    publication: PublicationWithRelations,
    lang?: string
  ): PublicationTranslationWithRelations | undefined {
    const translation = publication.translations?.find(
      (translation) => translation.localeId === (lang === "en" ? 2 : 1)
    );
    return translation;
  }

  /* ---------------------------------------------------------
  TABLE CONTENT METHODS
  --------------------------------------------------------- */
  /** Prepares array of visible columns based on "visible" value */
  get visibleColumns() {
    return this.TABLE_COLUMNS.filter((column) => column.visible).map(
      (column) => column.property
    );
  }

  trackByProperty<T>(index: number, column: TableColumn<T>) {
    return column.property;
  }
}
